import { createContext } from 'react';
import {
	IGetModifierInfoV2,
	IItemForGetShortInfo,
	IItemForGetShortInfoWithStatus,
	IGetModifierRestaurantProperties,
	TLanguageIDs,
	IGetModifierRestaurantPortions,
} from 'types';

export type TTypeOfModalWindow =
	| null
	| 'errorUpdatingModifier'
	| 'assignRestaurants'
	| 'editNestedModGroupTemplate'
	| 'assignPortionsRestaurants'
	| 'viewPortion'
	| 'errorModifierHasPortions';

export interface IViewModifierState {
	needRefetchData: boolean;
	needRefetchRestPropsData: boolean;
	needRefetchRestaurantPortionsData: boolean;
	modifierFullInfo: Nullable<IGetModifierInfoV2['data']>;
	accessibleRestaurants: IItemForGetShortInfoWithStatus[];
	accessiblePortionsRestaurants: IItemForGetShortInfo[];
	restaurantIdForRestaurantProps: Nullable<string>;
	restaurantProps: Nullable<IGetModifierRestaurantProperties['data']>;
	restaurantIdForPortions: Nullable<string>;
	restaurantPortions: Nullable<IGetModifierRestaurantPortions['data']>;
	selectedPortionId: string;
	selectedTranslationTab: Nullable<TLanguageIDs>;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const vieModifierInitialState: IViewModifierState = {
	needRefetchData: false,
	needRefetchRestPropsData: false,
	needRefetchRestaurantPortionsData: false,
	modifierFullInfo: null,
	accessibleRestaurants: [],
	accessiblePortionsRestaurants: [],
	restaurantIdForRestaurantProps: null,
	restaurantProps: null,
	restaurantIdForPortions: null,
	restaurantPortions: null,
	selectedPortionId: '',
	selectedTranslationTab: null,
	typeOfModalWindow: null,
};

export interface IViewModifierContext extends IViewModifierState {
	refetchData(value: boolean): void;
	refetchRestPropsData(value: boolean): void;
	setRestaurantIdForRestaurantProps(value: Nullable<string>): void;
	setRestaurantIdForPortions(value: Nullable<string>): void;
	refetchRestaurantPortionsData(value: boolean): void;
	changeSelectedPortionId(value: string): void;
	setTranslationTab(value: Nullable<TLanguageIDs>): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
}

export const ViewModifierContext = createContext<IViewModifierContext>({
	refetchData: () => undefined,
	refetchRestPropsData: () => undefined,
	setRestaurantIdForRestaurantProps: () => undefined,
	setRestaurantIdForPortions: () => undefined,
	refetchRestaurantPortionsData: () => undefined,
	changeSelectedPortionId: () => undefined,
	setTranslationTab: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	...vieModifierInitialState,
});
